import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { CellContext, ColumnDef } from '@tanstack/react-table';

import Chip from 'components/Chip/Chip';
import { DATE_TIME_FORMAT_SHORTER } from 'constants/constants';
import ActionCell from 'components/DataTableComponent/components/ActionCell';
import { Subscription } from 'common/contracts';

export function useSubscriptionsColumns() {
  const navigate = useNavigate();

  const columns: ColumnDef<Subscription, unknown>[] = [
    { accessorKey: 'subscriptionId', header: 'Subscription id' },
    { accessorKey: 'playerId', header: 'Player id' },
    {
      accessorKey: 'createdAt',
      header: 'Subscribed since',
      cell: (cell: CellContext<any, unknown>) => {
        const subscribedSince = cell.getValue() as string;
        return subscribedSince
          ? dayjs(subscribedSince).utc().format(DATE_TIME_FORMAT_SHORTER)
          : '';
      }
    },
    { accessorKey: 'playerEmail', header: 'Player email' },
    { accessorKey: 'billingPeriod', header: 'Billing period' },
    {
      accessorKey: 'nextBilling',
      header: 'Next billing',
      cell: (cell: CellContext<any, unknown>) => {
        const subscribedSince = cell.getValue() as string;
        return subscribedSince
          ? dayjs(subscribedSince).utc().format(DATE_TIME_FORMAT_SHORTER)
          : '';
      }
    },
    { accessorKey: 'successfulBillings', header: 'Successful billings' },
    {
      accessorKey: 'status',
      header: 'Status',
      cell: (cell: CellContext<Subscription, unknown>) => {
        // todo: implement status check (API integration)
        //   const isActive = cell.getValue() as boolean;
        // const status = statusUtils.getOfferStatus(cell.row.original, isActive);

        return (
          <Chip variant="flat" status={'success'}>
            Active
          </Chip>
        );
      }
    },
    {
      accessorKey: 'actions',
      header: '',
      maxSize: 5,
      size: 5,
      cell: (cell: CellContext<any, unknown>) => {
        const { original } = cell.row;
        return (
          <ActionCell
            rowData={original}
            actions={[
              {
                label: 'Cancel',
                handler: () => {
                  console.log('cancel');
                }
              },
              {
                label: 'Show orders',
                handler: () => {}
              }
            ]}
          />
        );
      }
    }
  ];

  return { columns };
}
